import { Component } from "react";
import DataResult from "../data/bean/data_result";
import Config from "../Config";
import ListingWebServices from "../service/listing_web_services";
import ProposalServices from "../service/mrtt_proposal_web_service";
import UtilBloc from "./util_bloc";
import Labels from "../ui/constant/labels";
// import DeclarationFormSection from "../data/bean/declaration_form_section_bean";
import LanguageBloc from "./language_bloc";
import UserAccessBloc from "./user_access_bloc";
import FormsBloc from "./forms_bloc";
import moment from "moment";

class ProposalBloc extends Component {
  static async getListingCountData(
    id,
    entity,
    dateFilter,
    fromDate,
    toDate,
    sourceChannel
  ) {
    let condition = [
      {
        entity: entity,
        field: "trxTimestamp",
        value: fromDate,
        type: ">",
      },
      {
        entity: entity,
        field: "trxTimestamp",
        value: toDate,
        type: "<",
      },
    ];

    let payload = {};

    payload = {
      userId: id,
      dateCondition: condition,
      sourceChannel: sourceChannel
    }

    let response = await ProposalServices.getProposalCount(payload);

    return response;
  }

  static async getListingData(
    id,
    entity,
    sortCriteria,
    sortOrder,
    fromDate,
    toDate,
    status,
    page,
    keyword,
    sourceChannel
  ) {
    let condition = [];
    if (status === 'ALL') {
      condition = [
        {
          entity: entity,
          field: "trxTimestamp",
          value: fromDate,
          type: ">",
        },
        {
          entity: entity,
          field: "trxTimestamp",
          value: toDate,
          type: "<",
        },
      ];
    } else {
      condition = [
        {
          entity: entity,
          field: "trxTimestamp",
          value: fromDate,
          type: ">",
        },
        {
          entity: entity,
          field: "trxTimestamp",
          value: toDate,
          type: "<",
        },
        {
          entity: entity,
          field: "trxStatus",
          value: status=="SUBMITTED" ? status:"SUBMITTED",
          type: status=="SUBMITTED" ? "=" : "!=",
        },
      ]
    }


    let payload = {};

    payload = {
      userId: id,
      page: page,
      keyword: keyword,
      sortField: sortCriteria,
      sortBy: sortOrder,
      condition: condition,
      sourceChannel: sourceChannel
    }
    console.log('payload', payload)
    let response = await ProposalServices.getProposalListing(payload);
    console.log("response", response)
    return response;
  }

  static async deleteProposalById(id) {
    let resp = await ProposalServices.deleteProposalById(id);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async deleteUploadedDocumentById(id) {
    let resp = await ProposalServices.deleteProposalUploadedFile(id);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async generateProposalForm(id) {
    let resp = await ProposalServices.generateProposal(id);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async editGeneratedProposal(id) {
    try {
      let resp = await ProposalServices.editGeneratedProposal(id);
      if (resp.success) {
        return new DataResult(true, resp.message, resp.data);
      } else {
        return new DataResult(false, resp.message);
      }
    } catch (error) {
      return new DataResult(false, error.response.data?.message, error.response.data);
    }

  }

  static async getDeclarationQuestions(payload) {
    let resp = await ProposalServices.getDeclarationQuestions(payload);
    if (resp.success) {
      let declarationFormSections = [];
      declarationFormSections = this.convertToSectionAndQuestion(resp.data);
      return new DataResult(true, resp.message, declarationFormSections);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  // static convertToSectionAndQuestion(result) {
  //   let declarationFormSections = [];
  //   let section;
  //   result.map((data, index) => {
  //     section = new DeclarationFormSection(index + 1, "", "", []);
  //     data.form.properties.questions.map((item, pos) => {
  //       section.questions.push({
  //         id: pos + 1,
  //         questionText: item.question.en,
  //         questionTextBM: item.question.bm,
  //         selection: null,
  //         enabled: pos === 0,
  //         redAlertText: item.errorMessage,
  //         popUpErrorCode: "",
  //         canSelect: true,
  //         hasDialogPopup: false,
  //         category: "HQ",
  //         spanList: [],
  //         code: "",
  //         compulsoryYes: true,
  //         questionType: "YESNO",
  //         freeText: "",
  //         checkboxes: null,
  //         answerProperties: item.answerProperties,
  //       });
  //     });
  //     declarationFormSections.push(section);
  //   });
  //   return declarationFormSections;
  // }

  static async createNewProposal(data) {
    let payload = {
      quotationId: data.id,
      sourceChannel: data.sourceChannel,
      isEdit: false,
    };
    let resp = await ProposalServices.newProposal(payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async submitProposal(proposalData) {
    let resp = await ProposalServices.submitProposal(proposalData);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async proposalSubmissionStatus(proposalId) {
    console.log("check proposal id", proposalId)
    let payload = {
      proposalId: proposalId
    }
    let resp = await ProposalServices.fetchSubmitProposalStatus(payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async uploadProposalDocument(payload) {
    let resp = await ProposalServices.submitProposalDocument(payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async submitForReview(proposalId, otpChannel, isResend) {
    let resp;
    if (isResend) {
      resp = await ProposalServices.submitForReviewResend(
        proposalId
      );
    } else {
      resp = await ProposalServices.submitForReview(proposalId, otpChannel);
    }

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async changeOTPChannel(otpId, id) {
    let payload = {
      otpChannel: otpId,
      proposalId: id
    }
    let resp = await ProposalServices.changeOTPChannel(payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async saveFormProposal(id, category, payload, user = 'agent') {
    let resp = await ProposalServices.saveFormProposal(id, category, payload, user);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async deleteFormInProposal(id, category) {
    let resp = await ProposalServices.deleteFormDataProposal(id, category);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getFormDetailProposal(id, code, user = 'agent') {
    let result = {};
    let payload = {
      proposalId: id,
      category: code
    }
    let response = await ProposalServices.getProposal(payload, user);
    if (response.success) {
      switch (code) {
        case Config.formProposalDetailMapping[0].category:
          result = this.mapProposalPersonalDetailsForm(response);
          break;
        case Config.formProposalDetailMapping[1].category:
          result = this.mapProposalMortgageDetailsForm(response);
          break;
        case Config.formProposalDetailMapping[2].category:
          result = this.mapProposalHealthStatementForm(response);
          break;
        case Config.formProposalDetailMapping[3].category:
          result = this.mapProposalExtendedHealthForm(response);
          break;
        case Config.formProposalDetailMapping[4].category:
          result = this.mapProposalForeignerForm(response);
          break;
        case Config.formProposalDetailMapping[5].category:
          result = this.mapProposalGeneralOccForm(response);
          break;
        case Config.formProposalDetailMapping[6].category:
          result = this.mapProposalOilGasForm(response, id);
          break;
        case Config.formProposalDetailMapping[7].category:
          result = this.mapProposalResTravelForm(response);
          break;
        case Config.formProposalDetailMapping[8].category:
          result = this.mapProposalDirectCreditForm(response);
          break;
        case Config.formProposalDetailMapping[9].category:
          result = response;
          break;
        case Config.formProposalDetailMapping[10].category:
          result = response;
          break;
        case Config.formProposalDetailMapping[12].category:
          result = this.mapProposalCreditCardPaymentForm(response);
          break;
        case Config.formProposalDetailMapping[13].category:
          result = this.mapProposalPayorDetailsForm(response);
          break;
        default:
          break;
      }
    }
    return result;
  }

  static async mapProposalPersonalDetailsForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let userData = await UserAccessBloc.getUserData();
    let proposalDetail = await this.getProposalDetail(response.data[0]?.proposal_attr.proposalId, userData.username); //'SHA002'
    console.log("personal", formData)
    let record = {
      occupationClass: formData?.occupationClass || '',
      quotationDate: formData?.quotationDate || '',
      proposalDate: formData?.proposalDate || proposalDetail.proposalCreatedDate,
      natureBusiness: formData?.natureOfBusiness || '',
      isSmoker: formData?.smoker || '',
      occupation: formData?.occupation || '',
      anb: formData?.anb || '',
      name: formData.name,
      gender: formData.gender,
      title: formData?.title || null,
      idType: formData.idType.code,
      idNo: formData.idType.code == 'IC' ? formData.idNo : formData.otherIdNo,
      addIDType: formData.addIDType || null,
      addIDNo: formData.addIDType === 'oldIcNo' ? formData.oldIcNo || null : formData.addIDType === 'birthCertNo' ? formData.birthCertNo || null : null,
      dob: formData.dob,
      maritalStatus: formData?.maritalStatus || null,
      race: formData?.race || null,
      religion: formData?.religion || null,
      isMalaysian: formData?.malaysian || null,
      placeOfBirth: formData?.placeOfBirth || null,
      placeOfBirth2: formData?.placeOfBirth2 || null,
      placeOfBirth3: formData?.placeOfBirth3 || null,
      isLivingInMalaysia: formData?.currentLivingInMalaysia || null,
      country: formData?.country || null,
      corrCountry: formData?.corrCountry || null,
      correspondenceAddress: formData?.corrAddress || null,
      correspondenceAddress2: formData?.corrAddress2 || null,
      correspondenceAddress3: formData?.corrAddress3 || null,
      state: formData?.state || null,
      corrState: formData?.corrState || null,
      corrPostcode: formData?.corrPostcode || null,
      city: formData?.city || null,
      corrCity: formData?.corrCity || null,
      // isPermamentAddressCorrespondenceAddress: formData?.permanentAddrSameAsCorrAddr || null,
      isResidentialAddressCorrespondenceAddress: formData?.residentialAddrSameAsCorrAddr || null,
      // permanentAddress: formData?.permanentAddr || null,
      residentialAddress: formData?.residentialAddr || null,
      residentialAddress2: formData?.residentialAddr2 || null,
      residentialAddress3: formData?.residentialAddr3 || null,
      residentialState: formData?.residentialState || null,
      residentialPostcode: formData?.residentialPostcode || null,
      residentialCity: formData?.residentialCity || null,
      residentialCountry: formData?.residentialCountry || null,
      annualIncome: formData?.annualIncome || null,
      exactAnnualIncome: formData?.exactAnnualIncome ? parseFloat(formData?.exactAnnualIncome.replace(/,/g, '')).toFixed(2) : null,
      exactDuties: formData?.exactDuties || null,
      mobileNo: formData?.mobileNumber || null,
      officePhoneNo: formData?.officePhoneNumber || null,
      homePhoneNo: formData?.homePhoneNumber || null,
      email: formData?.email || null,
      companyName: formData?.employerName || null,
      companyAddress: formData?.employerAddr || null,
      companyAddress2: formData?.employerAddr2 || null,
      companyAddress3: formData?.employerAddr3 || null,
      companyCountry: formData?.employerCountry || null,
      companyState: formData?.employerState || null,
      companyCity: formData?.employerCity || null,
      companyPostcode: formData?.employerPostcode || null,
      preferContactMode: formData?.preferContactEmail == 'Yes' ? 'Email' : formData?.preferContactMobile == 'Yes' ? 'Mobile Number' : null,
      // From user data
      representativeName: formData?.representativeName || userData?.displayName || '',
      branchCode: formData?.branchCode || userData?.roles?.[0]?.branch || '',
      staffCode: formData?.staffCode || userData?.username || '',
      staffIcNo: formData?.staffIcNo || userData?.icNo || '',
      staffPhone: formData?.staffPhoneNo || userData?.phoneNo || '',
      staffEmail: formData?.staffEmail || userData?.email || '',
    }
    return record;
  }

  static mapProposalMortgageDetailsForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      financingInstitution: formData?.financingBank || null,
      financingRefNo: formData?.financingReferenceNo || null,
      financed: formData?.financed || null,
      paymentMethod: formData?.paymentMethod || null,
      financingAmount: formData?.financingAmount || null,
      loanTerm: formData?.loanTerm || null,
      defermentPeriod: formData?.defermentPeriod || null,
      coverageTerm: formData?.coverageTerm || null,
      benefit: formData?.initialSumCovered || null,
      criticalIllnessSumCovered: formData?.criticalIllnessSumCovered || null,
      criticalIllnessProtection: formData?.criticalIllnessProtection || null,
      initialSumCovered: formData?.initialSumCovered || null,
      contributionAmount: formData?.totalSingleContribution || null,
      sourceChannel: formData?.sourceChannel || null,
    }
    return record;
  }

  static mapProposalDirectCreditForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      accHolderName: formData?.accountHolderName || null,
      bankAccNo: formData?.bankAccountNo || null,
      bankName: formData?.bankCode || null,
    }
    return record;
  }


  static mapProposalCreditCardPaymentForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      isTermsAndConditionChecked: formData?.isTermsAndConditionChecked || null,
      creditCardNo: formData?.creditCardNo || null,
      cardHolderName: formData?.cardHolderName || null,
      isAuthorisedChecked: formData?.isAuthorisedChecked || null,
      issueBankCode: formData?.issueBankCode || null,
      creditCardType: formData?.creditCardType || null,
      creditCardExpiryDate: formData?.creditCardExpiryDate || null,
    }
    return record;
  }

  static mapProposalPayorDetailsForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      isPayorPersonCovered: formData?.isPayorPersonCovered || null,
      relationshipToPersonCovered: formData?.relationshipToPersonCovered || null,
      specifyRelationship: formData?.specifyRelationship || null,
      addIDType: formData?.addIDType || null,
      birthCertNo: formData?.addIDType === 'birthCertNo' ? formData?.birthCertNo || null : null,
      oldIcNo: formData?.addIDType === 'oldIcNo' ? formData?.oldIcNo || null : null,
      addIDNo: formData?.addIDType === 'oldIcNo' ? formData?.oldIcNo : formData?.addIDType === 'birthCertNo' ? formData?.birthCertNo : null,
      annualIncome: formData?.annualIncome || null,
      exactAnnualIncome: formData?.exactAnnualIncome ? parseFloat(formData?.exactAnnualIncome.replace(/,/g, '')).toFixed(2) : null,
      mobileNo: formData?.mobileNumber || null,
      officePhoneNo: formData?.officePhoneNumber || null,
      homePhoneNo: formData?.homePhoneNumber || null,
      email: formData?.email || null,
      companyName: formData?.employerName || null,
      companyAddress: formData?.employerAddr || null,
      companyAddress2: formData?.employerAddr2 || null,
      companyAddress3: formData?.employerAddr3 || null,
      companyCountry: formData?.employerCountry || null,
      companyState: formData?.employerState || null,
      companyCity: formData?.employerCity || null,
      companyPostcode: formData?.employerPostcode || null,
      isResidentialAddressCorrespondenceAddress: formData?.residentialAddrSameAsCorrAddr || null,
      residentialAddress: formData?.residentialAddr || null,
      residentialAddress2: formData?.residentialAddr2 || null,
      residentialAddress3: formData?.residentialAddr3 || null,
      residentialState: formData?.residentialState || null,
      residentialPostcode: formData?.residentialPostcode || null,
      residentialCity: formData?.residentialCity || null,
      residentialCountry: formData?.residentialCountry || null,
      nationality: formData?.nationality || null,
      corrCountry: formData?.corrCountry || null,
      correspondenceAddress: formData?.corrAddress || null,
      correspondenceAddress2: formData?.corrAddress2 || null,
      correspondenceAddress3: formData?.corrAddress3 || null,
      corrState: formData?.corrState || null,
      corrPostcode: formData?.corrPostcode || null,
      corrCity: formData?.corrCity || null,
      dob: formData?.dob ? moment(formData.dob, 'YYYY/MM/DD') : null,
      idType: formData?.idType?.code || null,
      idNo: formData?.idType?.code == 'IC' ? formData?.idNo : formData?.otherIdNo,
      name: formData?.name || null,
      natureBusiness: formData?.natureOfBusiness || '',
      occupationClass: formData?.occupationClass || '',
      occupation: formData?.occupation || '',
    }
    return record;
  }

  static mapProposalHealthStatementForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      isReceivedTreatment: formData?.q1 || null,
      isContinuouslyReceiveMedication: formData?.q3 || null,
      isAdvisedMedicalTest: formData?.q2 || null,
    }
    return record;
  }

  static mapProposalExtendedHealthForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      height: formData?.q1 || null,
      weight: formData?.q2 || null,
      isSmoker: formData?.q3 || null,
      isConsultOrTreatment: formData?.q5 || null,
      hasGeneticDisorder: formData?.q7 || null,
      hasHeartDisease: formData?.q4a || false,
      hasHighBloodPressure: formData?.q4b || false,
      hasMentalIllness: formData?.q4c || false,
      hasCancer: formData?.q4d || false,
      hasHIV: formData?.q4e || false,
      hasDiabetes: formData?.q4f || false,
      hasObstructivePulmonaryDisease: formData?.q4g || false,
      hasLiverDisease: formData?.q4h || false,
      hasKidneyDisease: formData?.q4i || false,
      lossSenses: formData?.q4j || false,
      physicalDisability: formData?.q4k || false,
      prolongedFatigue: formData?.q6a || false,
      unexplainedWeightLoss: formData?.q6b || false,
      abnormalLump: formData?.q6c || false,
      bloodUrine: formData?.q6d || false,
      newPain: formData?.q6e || false,
      isPregnant: formData?.q8 || null,
      details: formData?.details || null
    }
    return record;
  }

  static mapProposalForeignerForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      arriveDate: formData?.arrivalDate ? moment(formData.arrivalDate, 'YYYY/MM/DD') : null,
      stayDuration: formData?.yearStay || null,
      statusInMalaysia: formData?.officialStatus || null,
      positionNduties: formData?.positionExactDuties || null,
      isBank: formData?.bankAccount || "No",
      isProperty: formData?.property || "No",
      isInvestment: formData?.investment || "No",
      isBusiness: formData?.business || "No",
      isRelatives: formData?.relatives || "No",
      isSpouseMalaysian: formData?.spouseMalaysian || null,
      spouseOccupation: formData?.spouseOccupation || null,
      spouseNationality: formData?.spouseNationality || null,
      familyMember: formData?.spouseReside || null,
      isTravel: formData?.intendTravel || null,
      reasonForCert: formData?.certReason || null,
      isBankDetails: formData?.bankAccouuntDetails || null,
      isPropertyDetails: formData?.propertyDetails || null,
      isInvestmentDetails: formData?.investmentDetails || null,
      isBusinessDetails: formData?.businessDetails || null,
      isRelativesDetails: formData?.relativesDetails || null,
      travelFreq: formData?.intendTravelDetails || null,
      isDunHave: formData?.bankAccount == 'No' && formData?.property == 'No' && formData?.investment == 'No' && formData?.business == 'No' && formData?.relatives == 'No' ? 'Yes' : 'No',
      otherStatusInMalaysia: formData?.officialStatusDetails || null,
    }
    return record;
  }

  static mapProposalGeneralOccForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      occupation: formData?.occIndustryEngage || null,
      isJobScopeHeavy: formData?.liftingHeavy ? 'Yes' : "No",
      isJobScopeHighOrLow: formData?.undergroundHeight ? 'Yes' : "No",
      isJobScopeChemical: formData?.chemicalWorking ? 'Yes' : "No",
      isJobScopeVoltages: formData?.highVoltage ? 'Yes' : "No",
      isJobScopeEquipment: formData?.machinerary ? 'Yes' : "No",
      isJobScopeVessels: formData?.vesselWorking ? 'Yes' : "No",
      isJobScopeTravelAirCraft: formData?.travel ? 'Yes' : "No",
      isJobScopeEnv: formData?.env ? 'Yes' : "No",
      isAccident: formData?.accident || null,
      workingDuration: formData?.yearsWorking || null,
      isHealtAffectedByOcc: formData?.affectHealth || null,
      isChangeWork: formData?.switchJob || null,
      isJobScopeHeavyDetails: formData?.liftingHeavy || null,
      isJobScopeHighOrLowDetails: formData?.undergroundHeight || null,
      isJobScopeChemicalDetails: formData?.chemicalWorking || null,
      isJobScopeEquipmentDetails: formData?.machinerary || null,
      isJobScopeVesselsDetails: formData?.vesselWorking || null,
      isJobScopeVoltagesDetails: formData?.highVoltage || null,
      isJobScopeTravelAirCraftDetails: formData?.travel || null,
      isJobScopeEnvDetails: formData?.env || null,
      isAccidentDetails: formData?.accident || null,
      isChangeWorkNatureDetails: formData?.switchJob || null,
    }
    return record;
  }

  static async mapProposalOilGasForm(response, proposalId) {
    let personalFormData = await this.getFormDetailProposal(proposalId, Config.formProposalDetailMapping[0].category);
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      occupation: formData?.occIndustryEngage || personalFormData?.occupation,
      exactDuties: formData?.natureOfOccupation || personalFormData?.exactDuties,
      workingDuration: formData?.yearsWorking || null,
      isHazardousDuties: formData?.hazard || null,
      isJobScopeHeavy: formData?.lifting || "No",
      isJobScopeChemical: formData?.chemical || "No",
      isJobScopeEquipment: formData?.equipment || "No",
      isJobScopeExplosives: formData?.explosive || "No",
      isJobScopeVoltages: formData?.voltage || "No",
      isJobScopeUnderwater: formData?.underwater || "No",
      isAccident: formData?.accident || null,
      rigLocation: formData?.rigSituated || null,
      travelFreqToRig: formData?.travelToOilRigPerAnnum || null,
      isHelicopter: formData?.transportHelicopter || "No",
      isOthers: formData?.transportOther ? 'Yes' : "No",
      hazardousDetails: formData?.hazardDetails || null,
      isAccidentDetails: formData?.accidentDetails || null,
      isJobScopeHeavyDetails: formData?.liftingDetails || null,
      isJobScopeChemicalDetails: formData?.chemicalDetails || null,
      isJobScopeEquipmentDetails: formData?.equipmentDetails || null,
      isJobScopeExplosivesDetails: formData?.explosiveDetails || null,
      isJobScopeVoltagesDetails: formData?.voltageDetails || null,
      helicopterToRigDuration: formData?.transportHelicopterDurationHour || null,
      helicopterToRigFreq: formData?.transportHelicopterFreqTravel || null,
      otherDetails: formData?.transportOther || null,
      isJobScopeNo: formData?.lifting == 'No' && formData?.chemical == 'No' && formData?.equipment == 'No'
        && formData?.explosive == 'No' && formData?.voltage == 'No' && formData?.underwater == 'No' ? 'Yes' : 'No'
    }
    console.log("oilgas", formData)
    return record;
  }

  static mapProposalResTravelForm(response) {
    let formData = response.data[0]?.proposal_attr?.properties;
    let record = {
      stayDuration: formData?.durationOfResidence || null,
      residenceOrTravelAddress: formData?.residenceAddr || null,
      residenceOrTravelCountry: formData?.residenceCountry || null,
      residenceOrTravelState: formData?.state || null,
      residenceOrTravelPostcode: formData?.postcode || null,
      residenceOrTravelCity: formData?.city || null,
      travelStayDuration: formData?.stay || null,
      isFirstEMploymentReason: formData?.firstVisit || null,
      isStayThroughout: formData?.locationRemaining || null,
      typeOfStay: formData?.accomType || null,
      acommodationLocated: formData?.accomLocated || null,
      liveWorkCondition: formData?.workingCond || null,
      politicalSituation: formData?.politicCond || null,

      notFisrtEmployment: formData?.firstVisitDetails || null,
      notStayThroughoutAddress: formData?.otherStayAddr || null,
      notStayThroughoutCountry: formData?.otherStayCountry || null,
      notStayThroughoutState: formData?.otherStayState || null,
      notStayThroughoutPostcode: formData?.otherStayPostcode || null,
      notStayThroughoutCity: formData?.otherStayCity || null,
      otherAccommodationType: formData?.otherAccomTypeDetails || null,
    }
    return record;
  }

  static mapProposalForm(response) {
    let record = null;
    if (response.data.length > 0) {
      record = response.data[0].proposal_attr?.properties;
    }
    return record;
  }

  static async getProposalDetail(id, userId) {
    let payload = {
      id: id,
      userId: userId
    };
    let result = {};

    let response = await ProposalServices.getProposalDetails(
      payload
    );
    if (response.success) {
      result = this.mapProposalDetail(response);
      console.log("mapping result", result);
    }
    return result;
  }

  static async getProposalByQuotationId(quotationId) {
    let payload = {
      quotationId: quotationId,
    };
    let response = await ProposalServices.getProposalByQuotationId(payload);
    return response.data;
  }

  static async mapProposalDetail(response) {
    let generatedDocument = [];
    let countryList = (await FormsBloc.getCountryList()).data || [];
    let occupationList = (await FormsBloc.getOccupationList()).data || [];

    // Getting Generated Documents
    response.data?.uploaded_document.data.forEach((item) => {
      let record = {};
      record = {
        filename: item.document?.name !== null ? item.document?.name : item.uploaded_document?.properties?.filename,
        value: item.uploaded_document.id,
        size: item.uploaded_document.properties.sizeMB,
        type: item.uploaded_document.reference1,
        code: item.document.code,
      };
      generatedDocument.push(record);
    });
    // Getting Document Requirement
    let requirement = {
      allowedFormat: response.data?.uploaded_document.data[0]?.document?.properties?.allowedFormat ? response.data.uploaded_document.data[0].document.properties.allowedFormat : ['PDF', 'JPEG', 'JPG', 'PNG'],
      maxFileUpload: response.data?.uploaded_document.data[0]?.document?.properties?.maxFileUpload ? response.data.uploaded_document.data[0].document.properties.maxFileUpload : 5,
      maxSizeGB: response.data?.uploaded_document.data[0]?.document?.properties?.maxSizeGB ? response.data.uploaded_document.data[0].document.properties.maxSizeGB : 0.01,
    };


    let indexOfPersonalDetails = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[0].category
    );

    // console.log("index personal detail", indexOfPersonalDetails);

    let indexOfHealthStatement = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[2].category
    );
    // console.log("index personal statement", indexOfHealthStatement);

    let indexOfMortgageDetails = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[1].category
    );

    let indexOfExtendedHealth = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[3].category
    );

    // console.log("index E credit", indexOfExtendedHeath);

    let indexOfForeignerDetails = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[4].category
    );

    console.log("index foreigner", indexOfForeignerDetails);

    let indexOfGeneralOcc = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[5].category
    );

    // console.log("index foreigner", indexOfGeneralOcc);

    let indexOfOilGasDetails = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[6].category
    );

    // console.log("index foreigner", indexOfOilGasDetails);

    let indexOfResTravelDetails = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[7].category
    );

    let indexOfDirectCredit = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[8].category
    );

    let indexOfSubmitReview = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[11].category
    );

    let indexOfCreditCardPaymentDetails = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[12].category
    );

    let indexOfPayorInformation = response.data?.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMapping[13].category
    );

    // console.log("index foreigner", indexOfDirectCredit);

    let personalDetailsAttr = null;
    if (indexOfPersonalDetails || indexOfPersonalDetails === 0) {
      personalDetailsAttr =
        response.data.attributes.data[indexOfPersonalDetails];
    }

    let healthStatementAttr = null;
    if (indexOfHealthStatement || indexOfHealthStatement === 0) {
      healthStatementAttr =
        response.data.attributes.data[indexOfHealthStatement];
    }

    let mortgageDetailsAttr = null;
    if (indexOfMortgageDetails || indexOfMortgageDetails === 0) {
      mortgageDetailsAttr =
        response.data.attributes.data[indexOfMortgageDetails];
    }

    let extendedHealthDetailsAttr = null;
    let extendedHealthDetailsQ4aAttr = null;
    let extendedHealthDetailsQ4bAttr = null;
    let extendedHealthDetailsQ4cAttr = null;
    let extendedHealthDetailsQ4dAttr = null;
    let extendedHealthDetailsQ4eAttr = null;
    let extendedHealthDetailsQ4fAttr = null;
    let extendedHealthDetailsQ4gAttr = null;
    let extendedHealthDetailsQ4hAttr = null;
    let extendedHealthDetailsQ4iAttr = null;
    let extendedHealthDetailsQ4jAttr = null;
    let extendedHealthDetailsQ4kAttr = null;
    let extendedHealthDetailsQ5Attr = null;
    let extendedHealthDetailsQ6aAttr = null;
    let extendedHealthDetailsQ6bAttr = null;
    let extendedHealthDetailsQ6cAttr = null;
    let extendedHealthDetailsQ6dAttr = null;
    let extendedHealthDetailsQ6eAttr = null;
    let extendedHealthDetailsQ7Attr = null;
    let extendedHealthDetailsQ8Attr = null;
    if (indexOfExtendedHealth || indexOfExtendedHealth === 0) {
      extendedHealthDetailsAttr =
        response.data.attributes.data[indexOfExtendedHealth];
      extendedHealthDetailsQ4aAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4a')[0]
      extendedHealthDetailsQ4bAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4b')[0]
      extendedHealthDetailsQ4cAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4c')[0]
      extendedHealthDetailsQ4dAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4d')[0]
      extendedHealthDetailsQ4eAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4e')[0]
      extendedHealthDetailsQ4fAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4f')[0]
      extendedHealthDetailsQ4gAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4g')[0]
      extendedHealthDetailsQ4hAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4h')[0]
      extendedHealthDetailsQ4iAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4i')[0]
      extendedHealthDetailsQ4jAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4j')[0]
      extendedHealthDetailsQ4kAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q4k')[0]
      extendedHealthDetailsQ5Attr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q5')[0]
      extendedHealthDetailsQ6aAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q6a')[0]
      extendedHealthDetailsQ6bAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q6b')[0]
      extendedHealthDetailsQ6cAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q6c')[0]
      extendedHealthDetailsQ6dAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q6d')[0]
      extendedHealthDetailsQ6eAttr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q6e')[0]
      extendedHealthDetailsQ7Attr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q7')[0]
      extendedHealthDetailsQ8Attr = this.filterDetailsByQuestionNo(extendedHealthDetailsAttr?.proposal_attr.properties?.details, 'q8')[0]
    }

    let foreignerDetailsAttr = null;
    if (indexOfForeignerDetails || indexOfForeignerDetails === 0) {
      foreignerDetailsAttr = response.data.attributes.data[indexOfForeignerDetails];
    }

    let generalOccAttr = null;
    if (indexOfGeneralOcc || indexOfGeneralOcc === 0) {
      generalOccAttr = response.data.attributes.data[indexOfGeneralOcc];
    }

    let oilGasDetailsAttr = null;
    if (indexOfOilGasDetails || indexOfOilGasDetails === 0) {
      oilGasDetailsAttr = response.data.attributes.data[indexOfOilGasDetails];
    }

    let resTravelDetailsAttr = null;
    if (indexOfResTravelDetails || indexOfResTravelDetails === 0) {
      resTravelDetailsAttr = response.data.attributes.data[indexOfResTravelDetails];
    }

    let directCreditAttr = null;
    if (indexOfDirectCredit || indexOfDirectCredit === 0) {
      directCreditAttr = response.data.attributes.data[indexOfDirectCredit];
    }

    let submitReviewAttr = null;
    if (indexOfSubmitReview || indexOfSubmitReview === 0) {
      submitReviewAttr = response.data.attributes.data[indexOfSubmitReview];
    }

    let creditCardPaymentDetailsAttr = null;
    if (indexOfCreditCardPaymentDetails || indexOfCreditCardPaymentDetails === 0) {
      creditCardPaymentDetailsAttr = response.data.attributes.data[indexOfCreditCardPaymentDetails];
    }

    let payorInformationAttr = null;
    if (indexOfPayorInformation || indexOfPayorInformation === 0) {
      payorInformationAttr = response.data.attributes.data[indexOfPayorInformation];
    }

    let dobCountry = (personalDetailsAttr?.proposal_attr.properties?.country && await (countryList.filter((item) => item.code === personalDetailsAttr?.proposal_attr.properties?.country)?.[0]?.reference1)) || "";
    let corrCountry = (personalDetailsAttr?.proposal_attr.properties?.corrCountry && await (countryList.filter((item) => item.code === personalDetailsAttr?.proposal_attr.properties?.corrCountry)?.[0]?.reference1)) || "";
    let employerCountry = (personalDetailsAttr?.proposal_attr.properties?.employerCountry && await (countryList.filter((item) => item.code === personalDetailsAttr?.proposal_attr.properties?.employerCountry)?.[0]?.reference1)) || "";
    let residenceCountry = (resTravelDetailsAttr?.proposal_attr.properties?.residenceCountry && await (countryList.filter((item) => item.code === resTravelDetailsAttr?.proposal_attr.properties?.residenceCountry)?.[0]?.reference1)) || "";
    let otherStayCountry = (resTravelDetailsAttr?.proposal_attr.properties?.otherStayCountry && await (countryList.filter((item) => item.code === resTravelDetailsAttr?.proposal_attr.properties?.otherStayCountry)?.[0]?.reference1)) || "";
    let oilOcc = (oilGasDetailsAttr?.proposal_attr.properties?.occIndustryEngage && await (occupationList.filter((item) => item.code === oilGasDetailsAttr.proposal_attr.properties.occIndustryEngage)?.[0]?.reference1)) || "";
    let spouseOcc = (foreignerDetailsAttr?.proposal_attr.properties?.spouseOccupation && await (occupationList.filter((item) => item.code === foreignerDetailsAttr.proposal_attr.properties.spouseOccupation)?.[0]?.reference1)) || "";
    let spouseNationality = (foreignerDetailsAttr?.proposal_attr.properties?.spouseNationality && await (countryList.filter((item) => item.code === foreignerDetailsAttr.proposal_attr.properties.spouseNationality)?.[0]?.reference1)) || "";
    let payorCorrCountry = (payorInformationAttr?.proposal_attr.properties?.corrCountry && await (countryList.filter((item) => item.code === payorInformationAttr?.proposal_attr.properties?.corrCountry)?.[0]?.reference1)) || "";
    let payorEmployerCountry = (payorInformationAttr?.proposal_attr.properties?.employerCountry && await (countryList.filter((item) => item.code === payorInformationAttr?.proposal_attr.properties?.employerCountry)?.[0]?.reference1)) || "";

    let data = {
      status: response.data?.proposal?.data[0]?.proposal.trxStatus || '',
      refNo: response.data?.proposal?.data[0]?.proposal.refNo || '',
      proposalNo: response.data?.proposal?.data[0]?.proposal.proposalNo || '',
      quotationId: response.data?.proposal?.data[0]?.proposal.quotationId || '',
      proposalCreatedDate: response.data?.proposal?.data[0]?.proposal.cms_createdOn ?
        moment(response.data?.proposal?.data[0]?.proposal.cms_createdOn).format('DD/MM/YYYY') : '',
      personalDetails: {
        representativeName: {
          caption: Labels.LBL_REPRESENTATIVE_NAME,
          value:
            personalDetailsAttr?.proposal_attr.properties.representativeName ??
            "-",
        },
        staffCode: {
          caption: Labels.LBL_STAFF_ID,
          value: personalDetailsAttr?.proposal_attr.properties?.staffCode || '-',
        },
        branchCode: {
          caption: Labels.LBL_REPRESENTATIVE_BRANCH_CODE,
          value:
            personalDetailsAttr?.proposal_attr.properties
              ?.branchCode || '',
        },
        proposalDate: {
          caption: Labels.LBL_REPRESENTATIVE_PROPOSAL_DATE,
          value:
            personalDetailsAttr?.proposal_attr.properties?.proposalDate ? moment(personalDetailsAttr.proposal_attr.properties?.proposalDate).format('DD/MM/YYYY') === 'Invalid date'
              ? personalDetailsAttr?.proposal_attr.properties?.proposalDate : moment(personalDetailsAttr.proposal_attr.properties?.proposalDate).format('DD/MM/YYYY') : '',
        },
        name: {
          caption: Labels.LBL_FULLNAME_NRIC,
          value: personalDetailsAttr?.proposal_attr.properties?.name || '',
        },
        gender: {
          caption: Labels.LBL_GENDER,
          value: personalDetailsAttr?.proposal_attr.properties?.gender || ''
          /* value: personalDetailsAttr.proposal_attr.properties.gender,   */
        },
        title: {
          caption: Labels.LBL_TITLE,
          value: personalDetailsAttr?.proposal_attr.properties?.title || ''
          /* value: personalDetailsAttr.proposal_attr.properties.title,  */
        },
        idType: {
          caption: Labels.LBL_ID_TYPE,
          // value: UtilBloc.convertToLocaleObject(
          //   personalDetailsAttr.proposal_attr.properties.typeId?.description,
          //   personalDetailsAttr.proposal_attr.properties.typeId?.description1
          // ),
          value: personalDetailsAttr?.proposal_attr.properties?.idType.code || ''
        },
        // otherTypeId: {
        //   caption: Labels.LBL_OTHER_IDTYPE,
        //   value:
        //     personalDetailsAttr.proposal_attr.properties.otherTypeId
        //       ?.description ?? "-"
        // },
        idNo: {
          caption: personalDetailsAttr?.proposal_attr.properties?.idType.code == 'IC' ? Labels.LBL_ID_NUMBER : Labels.LBL_OTHER_IDTYPE,
          value: personalDetailsAttr?.proposal_attr.properties?.idType.code == 'IC' ?
            personalDetailsAttr?.proposal_attr.properties?.idNo || '' : personalDetailsAttr?.proposal_attr.properties?.otherIdNo || '',
        },
        addIDType: {
          caption: Labels.LBL_ADDITIONAL_ID_TYPE,
          value: personalDetailsAttr?.proposal_attr.properties?.addIDType == 'oldIcNo' ? Labels.LBL_OLD_IC_NUMBER : personalDetailsAttr?.proposal_attr.properties?.addIDType == 'birthCertNo' ? Labels.LBL_BIRTH_CERT : '',
        },
        addIDNo: {
          caption: personalDetailsAttr?.proposal_attr.properties?.addIDType == 'oldIcNo' ? Labels.LBL_OLD_IC_NUMBER : personalDetailsAttr?.proposal_attr.properties?.addIDType == 'birthCertNo' ? Labels.LBL_BIRTH_CERT : Labels.LBL_OTHER_IDTYPE,
          value: personalDetailsAttr?.proposal_attr.properties?.addIDType == 'oldIcNo' ?
            personalDetailsAttr?.proposal_attr.properties?.oldIcNo || '' : personalDetailsAttr?.proposal_attr.properties?.addIDType == 'birthCertNo' ? personalDetailsAttr?.proposal_attr.properties?.birthCertNo || '' : '',
        },
        // otherIdNo: {
        //   caption: Labels.LBL_OTHER_NRIC_NO,
        //   value: personalDetailsAttr.proposal_attr.properties?.otherIdNo,
        // },
        dob: {
          caption: Labels.LBL_DOB,
          value: personalDetailsAttr?.proposal_attr.properties?.dob ? moment(personalDetailsAttr.proposal_attr.properties?.dob).format('DD/MM/YYYY') : '',
        },
        maritalStatus: {
          caption: Labels.LBL_MARTIAL_STATUS,
          value:
            personalDetailsAttr?.proposal_attr.properties?.maritalStatus || ''

          /* value: personalDetailsAttr.proposal_attr.properties.maritalStatus, */
        },
        race: {
          caption: Labels.LBL_RACE,
          value:
            personalDetailsAttr?.proposal_attr.properties?.race || ''
          /* value: personalDetailsAttr.proposal_attr.properties.race,  */
        },
        religion: {
          caption: Labels.LBL_RELIGION,
          value:
            personalDetailsAttr?.proposal_attr.properties?.religion || ''
          /* value: personalDetailsAttr.proposal_attr.properties.religion,    */
        },
        isMalaysian: {
          caption: Labels.LBL_MALAYSIAN,
          value:
            personalDetailsAttr?.proposal_attr.properties?.malaysian || ''
          /* value: personalDetailsAttr.proposal_attr.properties.religion,    */
        },
        pob: {
          caption: Labels.LBL_PLACE_OF_BIRTH,
          value: await UtilBloc.capitalizeWords(
            (personalDetailsAttr?.proposal_attr.properties?.placeOfBirth ? personalDetailsAttr?.proposal_attr.properties?.placeOfBirth + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.placeOfBirth2 ? personalDetailsAttr?.proposal_attr.properties?.placeOfBirth2 + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.placeOfBirth3 ? personalDetailsAttr?.proposal_attr.properties?.placeOfBirth3 + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.city ? personalDetailsAttr?.proposal_attr.properties?.city + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.state ? personalDetailsAttr?.proposal_attr.properties?.state + ', ' : '')
            + (dobCountry ? dobCountry : '')
          )
          /* value: personalDetailsAttr.proposal_attr.properties.religion,    */
        },
        /*  */
        isLivingMalaysia: {
          caption: Labels.LBL_CURRENTLY_LIVING_MALAYSIA,
          value:
            personalDetailsAttr?.proposal_attr.properties
              ?.currentLivingInMalaysia
        },
        correspondenceAddress: {
          caption: Labels.LBL_CORRESPONDENCE_ADDRESS,
          value: await UtilBloc.capitalizeWords(
            (personalDetailsAttr?.proposal_attr.properties?.corrAddress ? personalDetailsAttr?.proposal_attr.properties?.corrAddress + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.corrAddress2 ? personalDetailsAttr?.proposal_attr.properties?.corrAddress2 + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.corrAddress3 ? personalDetailsAttr?.proposal_attr.properties?.corrAddress3 + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.corrPostcode ? personalDetailsAttr?.proposal_attr.properties?.corrPostcode + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.corrCity ? personalDetailsAttr?.proposal_attr.properties?.corrCity + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.corrState ? personalDetailsAttr?.proposal_attr.properties?.corrState + ', ' : '')
            + (corrCountry ? corrCountry : '')
          )
        },

        isPermanentAddressSameAsCorrespondenceAddress: {
          caption: Labels.LBL_IS_PERMANENT_ADDRESS_CORRESPONDENCE_ADDRESS_SAME,
          value: personalDetailsAttr?.proposal_attr.properties?.permanentAddrSameAsCorrAddr
        },
        permanentAddress: {
          caption: Labels.LBL_PERMANENT_ADDRESS,
          value:
            (personalDetailsAttr?.proposal_attr.properties?.permanentAddrSameAsCorrAddr === 'Yes' ?
              null : personalDetailsAttr?.proposal_attr.properties?.permanentAddr + ', ' + (personalDetailsAttr?.proposal_attr.properties?.corrPostcode ? personalDetailsAttr?.proposal_attr.properties?.corrPostcode + ', ' : '')
              + (personalDetailsAttr?.proposal_attr.properties?.corrCity ? personalDetailsAttr?.proposal_attr.properties?.corrCity + ', ' : '')
              + (personalDetailsAttr?.proposal_attr.properties?.corrState ? personalDetailsAttr?.proposal_attr.properties?.corrState + ', ' : '')
              + (corrCountry ? corrCountry : ''))
        },
        isResidentialAddressSameAsCorrespondenceAddress: {
          caption: Labels.LBL_IS_RESIDENTIAL_ADDRESS_CORRESPONDENCE_ADDRESS_SAME,
          value:
            personalDetailsAttr?.proposal_attr.properties
              ?.residentialAddrSameAsCorrAddr
        },
        residentialAddress: {
          caption: Labels.LBL_RESIDENTIAL_ADDRESS,
          value:
            (personalDetailsAttr?.proposal_attr.properties?.residentialAddrSameAsCorrAddr === 'Yes' ?
              null : personalDetailsAttr?.proposal_attr.properties?.residentialAddr + ', '
              + (personalDetailsAttr?.proposal_attr.properties?.residentialAddr2 ? personalDetailsAttr?.proposal_attr.properties?.residentialAddr2 + ', ' : '')
              + (personalDetailsAttr?.proposal_attr.properties?.residentialAddr3 ? personalDetailsAttr?.proposal_attr.properties?.residentialAddr3 + ', ' : '')
              + (personalDetailsAttr?.proposal_attr.properties?.residentialPostcode ? personalDetailsAttr?.proposal_attr.properties?.residentialPostcode + ', ' : '')
              + (personalDetailsAttr?.proposal_attr.properties?.residentialCity ? personalDetailsAttr?.proposal_attr.properties?.residentialCity + ', ' : '')
              + (personalDetailsAttr?.proposal_attr.properties?.residentialState ? personalDetailsAttr?.proposal_attr.properties?.residentialState + ', ' : '')
              + (corrCountry ? corrCountry : ''))
        },
        // currentLivingCountry: {
        //   caption: Labels.LBL_CURRENT_LIVING_COUNTRY,
        //   value:
        //     personalDetailsAttr.proposal_attr.properties?.currentLivingCountry
        //       ?.name,
        // },
        occupation: {
          caption: Labels.LBL_OCCUPATION,
          value:
            personalDetailsAttr?.proposal_attr.properties?.occupation ? await FormsBloc.getOccupationNameByCode(personalDetailsAttr.proposal_attr.properties?.occupation) : ''
        },
        natureOfBusiness: {
          caption: Labels.LBL_NOB,
          value:
            personalDetailsAttr?.proposal_attr.properties?.natureOfBusiness ? await FormsBloc.getNobNameByCode(personalDetailsAttr.proposal_attr.properties?.occupation, personalDetailsAttr.proposal_attr.properties?.natureOfBusiness) : ''
        },
        occupationClass: {
          caption: Labels.LBL_OCCUPATION_CLASS,
          value:
            personalDetailsAttr?.proposal_attr.properties?.occupationClass
        },
        // countryCodeMobileNumber: {
        //   caption: Labels.LBL_COUNTRYCODE,
        //   value: personalDetailsAttr.proposal_attr.properties?.countryCodeMobileNumber?.description,
        //   // Temprorary disabled
        //   // prefix: "(+60) ",
        // },
        mobileNumber: {
          caption: Labels.LBL_MOBILE_PHONE,
          value: personalDetailsAttr?.proposal_attr.properties
            ?.mobileNumber
            ? `+6${personalDetailsAttr.proposal_attr.properties?.mobileNumber}`
            : "",
          // Temprorary disabled
          // prefix: "(+60) ",
        },
        // countryCodeOfficeNumber: {
        //   caption: Labels.LBL_COUNTRYCODE,
        //   value: personalDetailsAttr.proposal_attr.properties?.countryCodeOfficeNumber?.description,
        //   // Temprorary disabled
        //   // prefix: "(+60) ",
        // },
        officePhoneNumber: {
          caption: Labels.LBL_OFFICE_PHONE,
          value: personalDetailsAttr?.proposal_attr.properties
            ?.officePhoneNumber
            ? `+6${personalDetailsAttr.proposal_attr.properties?.officePhoneNumber}`
            : "",
          // temporary disbaled
          // prefix: personalDetailsAttr.proposal_attr.properties.officePhoneNumber
          //   ? "(+60) "
          //   : "",
        },
        homePhoneNumber: {
          caption: Labels.LBL_HOME_PHONE,
          value: personalDetailsAttr?.proposal_attr.properties
            ?.homePhoneNumber
            ? `+6${personalDetailsAttr.proposal_attr.properties?.homePhoneNumber}`
            : "",
          // temporary disbaled
          // prefix: personalDetailsAttr.proposal_attr.properties.officePhoneNumber
          //   ? "(+60) "
          //   : "",
        },
        annualIncome: {
          caption: Labels.LBL_ANNUAL_INCOME,
          value: personalDetailsAttr?.proposal_attr.properties?.annualIncome,
          prefix: 'RM '
        },
        exactAnnualIncome: {
          caption: Labels.LBL_EXACT_ANNUAL_INCOME,
          value: personalDetailsAttr?.proposal_attr.properties?.exactAnnualIncome,
          prefix: 'RM '
        },
        exactDuties: {
          caption: Labels.LBL_EXACT_DUTIES,
          value: personalDetailsAttr?.proposal_attr.properties?.exactDuties,
        },
        email: {
          caption: Labels.LBL_EMAIL,
          value: personalDetailsAttr?.proposal_attr.properties?.email,
        },

        companyName: {
          caption: Labels.LBL_EMPLOYER_COMPANY_NAME,
          value: personalDetailsAttr?.proposal_attr.properties?.employerName,
        },
        companyAddress: {
          caption: Labels.LBL_EMPLOYER_COMPANY_ADDRESS,
          value: await UtilBloc.capitalizeWords(
            (personalDetailsAttr?.proposal_attr.properties?.employerAddr ? personalDetailsAttr?.proposal_attr.properties?.employerAddr + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.employerAddr2 ? personalDetailsAttr?.proposal_attr.properties?.employerAddr2 + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.employerAddr3 ? personalDetailsAttr?.proposal_attr.properties?.employerAddr3 + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.employerPostcode ? personalDetailsAttr?.proposal_attr.properties?.employerPostcode + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.employerCity ? personalDetailsAttr?.proposal_attr.properties?.employerCity + ', ' : '')
            + (personalDetailsAttr?.proposal_attr.properties?.employerState ? personalDetailsAttr?.proposal_attr.properties?.employerState + ', ' : '')
            + (employerCountry ? employerCountry : ''))
        },


      },
      mortgageDetails: {
        sourceChannel: mortgageDetailsAttr?.proposal_attr?.properties?.sourceChannel,
        financingBank: {
          caption: Labels.LBL_BANK_NAME,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties?.financingBank
        },
        financingRefNo: {
          caption: Labels.LBL_FINANCING_REFERENCE_NO,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties?.financingReferenceNo
        },
        financed: {
          caption: Labels.LBL_FINANCED,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties.financed
        },
        financingAmount: {
          caption: Labels.LBL_FINANCE_AMOUNT,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties.financingAmount,
          prefix: "RM ",
        },
        defermentPeriod: {
          caption: Labels.LBL_DEFERMENT_PERIOD,
          value: mortgageDetailsAttr?.proposal_attr?.properties?.defermentPeriod,
        },
        coverageTerm: {
          caption: Labels.LBL_COVERAGE_TERM,
          value: mortgageDetailsAttr?.proposal_attr?.properties?.coverageTerm,
        },
        loanTerm: {
          caption: Labels.LBL_LOAN_TERM,
          value: mortgageDetailsAttr?.proposal_attr?.properties?.loanTerm,
        },
        benefit: {
          caption: Labels.LBL_BENEFIT,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties?.initialSumCovered,
          prefix: "RM ",
        },
        contributionAmount: {
          caption: Labels.LBL_CONTRIBUTION_AMOUNT,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties?.totalSingleContribution,
          prefix: "RM ",
        },
        criticalIllnessSumCovered: {
          caption: Labels.LBL_CRITICAL_ILLNESS_SUM_COVERED,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties?.criticalIllnessSumCovered,
          prefix: "RM ",
        },
        initialSumCovered: {
          caption: Labels.LBL_INITIAL_SUM_COVERED,
          value:
            mortgageDetailsAttr?.proposal_attr?.properties?.initialSumCovered,
          prefix: "RM ",
        },
      },
      directCredit: directCreditAttr ? {
        bankName: {
          caption: Labels.LBL_DIRECT_BANK_NAME,
          value:
            directCreditAttr?.proposal_attr.properties.bankCode ? await FormsBloc.getBankNameByCode(directCreditAttr?.proposal_attr.properties.bankCode) : ''
        },
        accountHolderName: {
          caption: Labels.LBL_ACC_HOLDER,
          value:
            directCreditAttr?.proposal_attr.properties.accountHolderName
          //value: eCreditAttr.proposal_attr.properties.categoryOfBank ?? "",
        },
        bankAccNo: {
          caption: Labels.LBL_ACC_NO,
          value: directCreditAttr?.proposal_attr.properties.bankAccountNo ?? "",
        },
      } : null,
      creditCardPayment: creditCardPaymentDetailsAttr ? {
        issueBankCode: {
          caption: Labels.LBL_CREDIT_CARD_BANK_NAME,
          value:
            creditCardPaymentDetailsAttr?.proposal_attr.properties.issueBankCode ? await FormsBloc.getBankNameByCode(creditCardPaymentDetailsAttr?.proposal_attr.properties.issueBankCode) : ''
        },
        cardHolderName: {
          caption: Labels.LBL_CREDIT_CARD_HOLDER_NAME,
          value:
            creditCardPaymentDetailsAttr?.proposal_attr.properties.cardHolderName
        },
        creditCardExpiryDate: {
          caption: Labels.LBL_CREDIT_CARD_EXPIRE_DATE,
          value: creditCardPaymentDetailsAttr?.proposal_attr.properties.creditCardExpiryDate ?? "",
        },
        creditCardNo: {
          caption: Labels.LBL_CREDIT_CARD_NO,
          value: creditCardPaymentDetailsAttr?.proposal_attr.properties.creditCardNo ?? "",
        },
        creditCardType: {
          caption: Labels.LBL_CREDIT_CARD_TYPE,
          value: creditCardPaymentDetailsAttr?.proposal_attr.properties.creditCardType ?? "",
        },
      } : null,
      healthStatement: {
        isDiagnosedDisease: {
          caption: Labels.LBL_MEDICAL_HISTORY,
          value: healthStatementAttr?.proposal_attr.properties?.q1,
        },
        isConsultation: {
          caption: Labels.LBL_CONSULTING,
          value: healthStatementAttr?.proposal_attr.properties?.q2,
        },
        isFollowUp: {
          caption: Labels.LBL_FOLLOW_UP,
          value:
            healthStatementAttr?.proposal_attr.properties?.q3
        },
      },
      payorInformation: payorInformationAttr ? {
        isPayorPersonCovered: {
          caption: Labels.LBL_IS_PAYOR_PERSON_COVERED,
          value: payorInformationAttr?.proposal_attr.properties?.isPayorPersonCovered,
        },
        relationshipToPersonCovered: {
          caption: Labels.LBL_RELATIONSHIP_TO_PERSON_COVERED,
          value: payorInformationAttr?.proposal_attr.properties?.relationshipToPersonCovered,
        },
        specifyRelationship: {
          caption: Labels.LBL_SPECIFY_RELATIONSHIP,
          value: payorInformationAttr?.proposal_attr.properties?.specifyRelationship,
        },
        name: {
          caption: Labels.LBL_FULLNAME_NRIC,
          value: payorInformationAttr?.proposal_attr.properties?.name || '',
        },
        idType: {
          caption: Labels.LBL_ID_TYPE,
          value: payorInformationAttr?.proposal_attr.properties?.idType.code || ''
        },
        idNo: {
          caption: payorInformationAttr?.proposal_attr.properties?.idType.code == 'IC' ? Labels.LBL_ID_NUMBER : Labels.LBL_OTHER_IDTYPE,
          value: payorInformationAttr?.proposal_attr.properties?.idType.code == 'IC' ?
            payorInformationAttr?.proposal_attr.properties?.idNo || '' : payorInformationAttr?.proposal_attr.properties?.otherIdNo || '',
        },
        addIDType: {
          caption: Labels.LBL_ADDITIONAL_ID_TYPE,
          value: payorInformationAttr?.proposal_attr.properties?.addIDType == 'oldIcNo' ? Labels.LBL_OLD_IC_NUMBER : payorInformationAttr?.proposal_attr.properties?.addIDType == 'birthCertNo' ? Labels.LBL_BIRTH_CERT : '',
        },
        addIDNo: {
          caption: payorInformationAttr?.proposal_attr.properties?.addIDType == 'oldIcNo' ? Labels.LBL_OLD_IC_NUMBER : payorInformationAttr?.proposal_attr.properties?.addIDType == 'birthCertNo' ? Labels.LBL_BIRTH_CERT : Labels.LBL_OTHER_IDTYPE,
          value: payorInformationAttr?.proposal_attr.properties?.addIDType == 'oldIcNo' ?
            payorInformationAttr?.proposal_attr.properties?.oldIcNo || '' : payorInformationAttr?.proposal_attr.properties?.addIDType == 'birthCertNo' ? payorInformationAttr?.proposal_attr.properties?.birthCertNo || '' : '',
        },
        dob: {
          caption: Labels.LBL_DOB,
          value: payorInformationAttr?.proposal_attr.properties?.dob ? (payorInformationAttr.proposal_attr.properties?.dob) : '',
        },
        correspondenceAddress: {
          caption: Labels.LBL_CORRESPONDENCE_ADDRESS,
          value: await UtilBloc.capitalizeWords(
            (payorInformationAttr?.proposal_attr.properties?.corrAddress ? payorInformationAttr?.proposal_attr.properties?.corrAddress + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.corrPostcode ? payorInformationAttr?.proposal_attr.properties?.corrPostcode + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.corrCity ? payorInformationAttr?.proposal_attr.properties?.corrCity + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.corrState ? payorInformationAttr?.proposal_attr.properties?.corrState + ', ' : '')
            + (payorCorrCountry ? payorCorrCountry : '')
          )
        },
        isResidentialAddressSameAsCorrespondenceAddress: {
          caption: Labels.LBL_IS_RESIDENTIAL_ADDRESS_CORRESPONDENCE_ADDRESS_SAME,
          value:
            payorInformationAttr?.proposal_attr.properties
              ?.residentialAddrSameAsCorrAddr
        },
        residentialAddress: {
          caption: Labels.LBL_RESIDENTIAL_ADDRESS,
          value:
            (payorInformationAttr?.proposal_attr.properties?.residentialAddrSameAsCorrAddr === 'Yes' ?
              null : payorInformationAttr?.proposal_attr.properties?.residentialAddr + ', '
              + (payorInformationAttr?.proposal_attr.properties?.residentialAddr2 ? payorInformationAttr?.proposal_attr.properties?.residentialAddr2 + ', ' : '')
              + (payorInformationAttr?.proposal_attr.properties?.residentialAddr3 ? payorInformationAttr?.proposal_attr.properties?.residentialAddr3 + ', ' : '')
              + (payorInformationAttr?.proposal_attr.properties?.residentialPostcode ? payorInformationAttr?.proposal_attr.properties?.residentialPostcode + ', ' : '')
              + (payorInformationAttr?.proposal_attr.properties?.residentialCity ? payorInformationAttr?.proposal_attr.properties?.residentialCity + ', ' : '')
              + (payorInformationAttr?.proposal_attr.properties?.residentialState ? payorInformationAttr?.proposal_attr.properties?.residentialState + ', ' : '')
              + (payorCorrCountry ? payorCorrCountry : ''))
        },
        occupation: {
          caption: Labels.LBL_OCCUPATION,
          value:
            payorInformationAttr?.proposal_attr.properties?.occupation ? await FormsBloc.getOccupationNameByCode(payorInformationAttr.proposal_attr.properties?.occupation) : ''
        },
        natureOfBusiness: {
          caption: Labels.LBL_NOB,
          value:
            payorInformationAttr?.proposal_attr.properties?.natureOfBusiness ? await FormsBloc.getNobNameByCode(payorInformationAttr.proposal_attr.properties?.occupation, payorInformationAttr.proposal_attr.properties?.natureOfBusiness) : ''
        },
        occupationClass: {
          caption: Labels.LBL_OCCUPATION_CLASS,
          value:
            payorInformationAttr?.proposal_attr.properties?.occupationClass
        },
        mobileNumber: {
          caption: Labels.LBL_MOBILE_PHONE,
          value: payorInformationAttr?.proposal_attr.properties
            ?.mobileNumber
            ? `+6${payorInformationAttr.proposal_attr.properties?.mobileNumber}`
            : "",
        },
        officePhoneNumber: {
          caption: Labels.LBL_OFFICE_PHONE,
          value: payorInformationAttr?.proposal_attr.properties
            ?.officePhoneNumber
            ? `+6${payorInformationAttr.proposal_attr.properties?.officePhoneNumber}`
            : "",
        },
        homePhoneNumber: {
          caption: Labels.LBL_HOME_PHONE,
          value: payorInformationAttr?.proposal_attr.properties
            ?.homePhoneNumber
            ? `+6${payorInformationAttr.proposal_attr.properties?.homePhoneNumber}`
            : "",
        },

        annualIncome: {
          caption: Labels.LBL_ANNUAL_INCOME,
          value: payorInformationAttr?.proposal_attr.properties?.annualIncome,
        },
        exactAnnualIncome: {
          caption: Labels.LBL_EXACT_ANNUAL_INCOME,
          value: payorInformationAttr?.proposal_attr.properties?.exactAnnualIncome,
          prefix: 'RM '
        },
        email: {
          caption: Labels.LBL_EMAIL,
          value: payorInformationAttr?.proposal_attr.properties?.email,
        },
        companyName: {
          caption: Labels.LBL_EMPLOYER_COMPANY_NAME,
          value: payorInformationAttr?.proposal_attr.properties?.employerName,
        },
        companyAddress: {
          caption: Labels.LBL_EMPLOYER_COMPANY_ADDRESS,
          value: await UtilBloc.capitalizeWords(
            (payorInformationAttr?.proposal_attr.properties?.employerAddr ? payorInformationAttr?.proposal_attr.properties?.employerAddr + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.employerAddr2 ? payorInformationAttr?.proposal_attr.properties?.employerAddr2 + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.employerAddr3 ? payorInformationAttr?.proposal_attr.properties?.employerAddr3 + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.employerPostcode ? payorInformationAttr?.proposal_attr.properties?.employerPostcode + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.employerCity ? payorInformationAttr?.proposal_attr.properties?.employerCity + ', ' : '')
            + (payorInformationAttr?.proposal_attr.properties?.employerState ? payorInformationAttr?.proposal_attr.properties?.employerState + ', ' : '')
            + (payorEmployerCountry ? payorEmployerCountry : '')
          )
        },
      } : null,
      extendedHealthDetails: extendedHealthDetailsAttr ? {
        q1: {
          caption: Labels.LBL_HEIGHT,
          value: extendedHealthDetailsAttr?.proposal_attr.properties?.q1,
          suffix: 'CM'
        },
        q2: {
          caption: Labels.LBL_WEIGHT,
          value: extendedHealthDetailsAttr?.proposal_attr.properties?.q2,
          suffix: 'KG'
        },
        q3: {
          caption: Labels.LBL_IS_SMOKER,
          value: extendedHealthDetailsAttr?.proposal_attr.properties?.q3,
        },
        q4: {
          caption: Labels.LBL_DIAGNOSED,
          value: [
            {
              questionNo: 'q4a',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4a || 'No',
              condition: extendedHealthDetailsQ4aAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.highBloodPressure,
              dateOfDiagnosis: extendedHealthDetailsQ4aAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4aAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4aAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4aAttr?.treatment || '',
            },
            {
              questionNo: 'q4b',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4b || 'No',
              condition: extendedHealthDetailsQ4bAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.highBloodPressure,
              dateOfDiagnosis: extendedHealthDetailsQ4bAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4bAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4bAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4bAttr?.treatment || '',
            },
            {
              questionNo: 'q4c',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4c || 'No',
              condition: extendedHealthDetailsQ4cAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.mentalIllness,
              dateOfDiagnosis: extendedHealthDetailsQ4cAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4cAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4cAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4cAttr?.treatment || '',
            },
            {
              questionNo: 'q4d',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4d || 'No',
              condition: extendedHealthDetailsQ4dAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isCancer,
              dateOfDiagnosis: extendedHealthDetailsQ4dAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4dAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4dAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4dAttr?.treatment || '',
            },
            {
              questionNo: 'q4e',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4e || 'No',
              condition: extendedHealthDetailsQ4eAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isHIV,
              dateOfDiagnosis: extendedHealthDetailsQ4eAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4eAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4eAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4eAttr?.treatment || '',
            },
            {
              questionNo: 'q4f',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4f || 'No',
              condition: extendedHealthDetailsQ4fAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isDiabetes,
              dateOfDiagnosis: extendedHealthDetailsQ4fAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4fAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4fAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4fAttr?.treatment || '',
            },
            {
              questionNo: 'q4g',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4g || 'No',
              condition: extendedHealthDetailsQ4gAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isPulmonaryDisease,
              dateOfDiagnosis: extendedHealthDetailsQ4gAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4gAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4gAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4gAttr?.treatment || '',
            },
            {
              questionNo: 'q4h',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4h || 'No',
              condition: extendedHealthDetailsQ4hAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isLiverDisease,
              dateOfDiagnosis: extendedHealthDetailsQ4hAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4hAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4hAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4hAttr?.treatment || '',
            },
            {
              questionNo: 'q4i',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4i || 'No',
              condition: extendedHealthDetailsQ4iAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isKidneyDisease,
              dateOfDiagnosis: extendedHealthDetailsQ4iAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4iAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4iAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4iAttr?.treatment || '',
            },
            {
              questionNo: 'q4j',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4j || 'No',
              condition: extendedHealthDetailsQ4jAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.lossSenses,
              dateOfDiagnosis: extendedHealthDetailsQ4jAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4jAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4jAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4jAttr?.treatment || '',
            },
            {
              questionNo: 'q4k',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q4k || 'No',
              condition: extendedHealthDetailsQ4kAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.physicalDisability,
              dateOfDiagnosis: extendedHealthDetailsQ4kAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ4kAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ4kAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ4kAttr?.treatment || '',
            },
          ]
        },
        q5: {
          caption: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isInvestigateOrOperation,
          value: [
            {
              questionNo: 'q5',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q5 || 'No',
              condition: extendedHealthDetailsQ5Attr?.condition || '',
              dateOfDiagnosis: extendedHealthDetailsQ5Attr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ5Attr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ5Attr?.doctorName || '',
              treatment: extendedHealthDetailsQ5Attr?.treatment || '',
            },
          ]
        },
        q6: {
          caption: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isConsultOrTreatment,
          value: [
            {
              questionNo: 'q6a',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q6a || 'No',
              condition: extendedHealthDetailsQ6aAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.prolongedFatigue,
              dateOfDiagnosis: extendedHealthDetailsQ6aAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ6aAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ6aAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ6aAttr?.treatment || '',
            },
            {
              questionNo: 'q6b',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q6b || 'No',
              condition: extendedHealthDetailsQ6bAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.unexplainedLossWeight,
              dateOfDiagnosis: extendedHealthDetailsQ6bAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ6bAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ6bAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ6bAttr?.treatment || '',
            },
            {
              questionNo: 'q6c',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q6c || 'No',
              condition: extendedHealthDetailsQ6cAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.abnormalLump,
              dateOfDiagnosis: extendedHealthDetailsQ6cAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ6cAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ6bAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ6bAttr?.treatment || '',
            },
            {
              questionNo: 'q6d',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q6d || 'No',
              condition: extendedHealthDetailsQ6dAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.bloodInUrine,
              dateOfDiagnosis: extendedHealthDetailsQ6dAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ6dAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ6dAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ6dAttr?.treatment || '',
            },
            {
              questionNo: 'q6e',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q6e || 'No',
              condition: extendedHealthDetailsQ6eAttr?.condition || Config.proposal.formDataMapping.step1.extendedHealthFormTitle.newPersistentPain,
              dateOfDiagnosis: extendedHealthDetailsQ6eAttr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ6eAttr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ6eAttr?.doctorName || '',
              treatment: extendedHealthDetailsQ6eAttr?.treatment || '',
            },
          ]
        },
        q7: {
          caption: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.hasGeneticDisorder,
          value: [
            {
              questionNo: 'q7',
              checked: extendedHealthDetailsAttr?.proposal_attr.properties?.q7 || 'No',
              condition: extendedHealthDetailsQ7Attr?.condition || '',
              dateOfDiagnosis: extendedHealthDetailsQ7Attr?.dateOfDiagnosis || '',
              doctorAddress: extendedHealthDetailsQ7Attr?.doctorAddress || '',
              doctorName: extendedHealthDetailsQ7Attr?.doctorName || '',
              treatment: extendedHealthDetailsQ7Attr?.treatment || '',
            },
          ]
        },
        q8: {
          caption: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isPregnant,
          value: extendedHealthDetailsAttr?.proposal_attr.properties?.q8
        },
        q8a: {
          caption: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.pregnancyMonth,
          value: extendedHealthDetailsQ8Attr?.pregnancyMonth
        },

      } : null,
      foreignerDetails: foreignerDetailsAttr ? {
        arrivalDate: {
          caption: Labels.LBL_ARRIVE_TIME,
          value: moment(foreignerDetailsAttr?.proposal_attr.properties?.arrivalDate).format('DD/MM/YYYY'),
        },
        yearStay: {
          caption: Labels.LBL_STAY_TIME,
          value: foreignerDetailsAttr?.proposal_attr.properties?.yearStay,
          suffix: 'years'
        },
        officialStatus: {
          caption: Labels.LBL_OFFICIAL_STATUS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.officialStatus,
        },
        officialStatusDetails: {
          caption: Labels.LBL_OTHERS_STATUS_DETAILS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.officialStatusDetails,
        },
        positionExactDuties: {
          caption: Labels.LBL_CURRENT_OCC_DUTIES,
          value: foreignerDetailsAttr?.proposal_attr.properties?.positionExactDuties,
        },
        bankAccount: {
          caption: Labels.LBL_BASED_IN_COUNTRY,
          value: foreignerDetailsAttr?.proposal_attr.properties?.bankAccount,
        },
        bankAccouuntDetails: {
          caption: Labels.LBL_BASED_IN_COUNTRY_DETAILS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.bankAccouuntDetails,
        },
        property: {
          caption: Labels.LBL_BASED_IN_COUNTRY,
          value: foreignerDetailsAttr?.proposal_attr.properties?.property,
        },
        propertyDetails: {
          caption: Labels.LBL_BASED_IN_COUNTRY_DETAILS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.propertyDetails,
        },
        business: {
          caption: Labels.LBL_BASED_IN_COUNTRY,
          value: foreignerDetailsAttr?.proposal_attr.properties?.business,
        },
        businessDetails: {
          caption: Labels.LBL_BASED_IN_COUNTRY_DETAILS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.businessDetails,
        },
        investment: {
          caption: Labels.LBL_BASED_IN_COUNTRY,
          value: foreignerDetailsAttr?.proposal_attr.properties?.investment,
        },
        investmentDetails: {
          caption: Labels.LBL_BASED_IN_COUNTRY_DETAILS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.investmentDetails,
        },
        spouseMalaysian: {
          caption: Labels.LBL_SPOUSE_MALAYSIAN,
          value: foreignerDetailsAttr?.proposal_attr.properties?.spouseMalaysian,
        },
        spouseOccupation: {
          caption: Labels.LBL_SPOUSE_OCCUPATION,
          value: spouseOcc || '',
        },
        spouseNationality: {
          caption: Labels.LBL_SPOUSE_NATIONALITY,
          value: spouseNationality || '',
        },
        spouseReside: {
          caption: Labels.LBL_SPOUSE_RESIDE,
          value: foreignerDetailsAttr?.proposal_attr.properties?.spouseReside,
        },
        intendTravel: {
          caption: Labels.LBL_TRAVEL_OTHER_COUNTRY,
          value: foreignerDetailsAttr?.proposal_attr.properties?.intendTravel,
        },
        intendTravelDetails: {
          caption: Labels.LBL_TRAVEL_OTHER_COUNTRY_DETAILS,
          value: foreignerDetailsAttr?.proposal_attr.properties?.intendTravelDetails,
        },
        certReason: {
          caption: Labels.LBL_CERT_REASON,
          value: foreignerDetailsAttr?.proposal_attr.properties?.certReason,
        },
      } : null,
      generalOccDetails: generalOccAttr ? {
        occIndustryEngage: {
          caption: Labels.LBL_OCCUPATION_ENGAGE,
          value: generalOccAttr?.proposal_attr.properties?.certReason,
        },
        liftingHeavy: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.liftingHeavy ? Labels.LBL_JOB_LIFTING : '',
        },
        liftingHeavyDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.liftingHeavy,
        },
        undergroundHeight: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.undergroundHeight ? Labels.LBL_JOB_UNDERGROUND_OR_HEIGHT : '',
        },
        undergroundHeightDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.undergroundHeight,
        },
        chemicalWorking: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.chemicalWorking ? Labels.LBL_JOB_CHEMICAL : '',
        },
        chemicalWorkingDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.chemicalWorking,
        },
        highVoltage: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.highVoltage ? Labels.LBL_JOB_HIGH_VOLTAGE : '',
        },
        highVoltageDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.highVoltage,
        },
        machinerary: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.machinerary ? Labels.LBL_JOB_MACHINARY : '',
        },
        machineraryDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.machinerary,
        },
        vesselWorking: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.vesselWorking ? Labels.LBL_JOB_ON_VESSELS : '',
        },
        vesselWorkingDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.vesselWorking,
        },
        travel: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.travel ? Labels.LBL_JOB_WITH_AIRCRAFT : '',
        },
        travelDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.travel,
        },
        env: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: generalOccAttr?.proposal_attr.properties?.env ? Labels.LBL_JOB_ADVERSE_ENV : '',
        },
        envDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.env,
        },
        accident: {
          caption: Labels.LBL_ACCIDENT_IN_DUTY,
          value: generalOccAttr?.proposal_attr.properties?.accident ? 'Yes' : 'No',
        },
        accidentDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.accident,
        },
        affectHealth: {
          caption: Labels.LBL_HEALTH_AFFECT,
          value: generalOccAttr?.proposal_attr.properties?.affectHealth ? 'Yes' : 'No',
        },
        affectHealthDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.affectHealth,
        },
        yearsWorking: {
          caption: Labels.LBL_CERT_REASON,
          value: generalOccAttr?.proposal_attr.properties?.yearsWorking,
          suffix: 'years'
        },
        switchJob: {
          caption: Labels.LBL_CHANGE_JOB,
          value: generalOccAttr?.proposal_attr.properties?.switchJob ? 'Yes' : 'No',
        },
        switchJobDetails: {
          indent: true,
          caption: Labels.LBL_JOB_DETAILS,
          value: generalOccAttr?.proposal_attr.properties?.switchJob,
        },
      } : null,
      oilGasDetails: oilGasDetailsAttr ? {
        occIndustryEngage: {
          caption: Labels.LBL_OCCUPATION,
          value: oilOcc || '',
        },
        natureOfOccupation: {
          caption: Labels.LBL_EXACT_DUTIES,
          value: oilGasDetailsAttr?.proposal_attr.properties?.natureOfOccupation,
        },
        yearsWorking: {
          caption: Labels.LBL_WORKING_TIME,
          value: oilGasDetailsAttr?.proposal_attr.properties?.yearsWorking,
          suffix: 'years'
        },
        lifting: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.lifting == 'Yes' ? 'Lifting or moving heavy equipment?' : '',
        },
        liftingDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.liftingDetails,
        },
        chemical: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.chemical == 'Yes' ? 'Working with chemicals or gases?' : '',
        },
        chemicalDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.chemicalDetails,
        },
        equipment: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.equipment == 'Yes' ? 'Working with any type of equipment?' : '',
        },
        equipmentDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.equipmentDetails,
        },
        explosive: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.explosive == 'Yes' ? 'Handling explosives?' : '',
        },
        explosiveDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.explosiveDetails,
        },
        voltage: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.voltage == 'Yes' ? 'Handling high voltages?' : '',
        },
        voltageDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.voltageDetails,
        },
        underwater: {
          caption: Labels.LBL_JOB_INVOLVE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.underwater == 'Yes' ? 'Underwater oil exploration?' : '',
        },
        // underwaterDetails: {
        //   caption: Labels.LBL_JOB_DETAILS,
        //   value: oilGasDetailsAttr?.proposal_attr.properties?.underwater == 'Yes' ? oilGasDetailsAttr?.proposal_attr.properties?.underwater : '',
        // },
        hazard: {
          caption: Labels.LBL_WORKING_WITH_HAZARD,
          value: oilGasDetailsAttr?.proposal_attr.properties?.hazard,
        },
        hazardDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.hazardDetails,
        },
        accident: {
          caption: Labels.LBL_WORKING_ACCIDENT,
          value: oilGasDetailsAttr?.proposal_attr.properties?.accident,
        },
        accidentDetails: {
          caption: Labels.LBL_JOB_DETAILS,
          value: oilGasDetailsAttr?.proposal_attr.properties?.accidentDetails,
        },
        rigSituated: {
          caption: Labels.LBL_WORKING_RIG_SITUATED,
          value: oilGasDetailsAttr?.proposal_attr.properties?.rigSituated,
        },
        travelToOilRigPerAnnum: {
          caption: Labels.LBL_TRAVEL_TO_RIG_ANNUM,
          value: oilGasDetailsAttr?.proposal_attr.properties?.travelToOilRigPerAnnum,
          suffix: 'per annum'
        },
        transportHelicopter: {
          caption: Labels.LBL_TRANSPORT_MODE,
          value: oilGasDetailsAttr?.proposal_attr.properties?.transportHelicopter == 'Yes' ? 'Helicopter' : oilGasDetailsAttr?.proposal_attr.properties?.transportOther,
        },
        transportHelicopterDurationHour: {
          caption: Labels.LBL_TRAVEL_TO_RIG_DURATION,
          value: oilGasDetailsAttr?.proposal_attr.properties?.transportHelicopter == 'Yes' && oilGasDetailsAttr?.proposal_attr.properties?.transportHelicopterDurationHour ? Number(oilGasDetailsAttr?.proposal_attr.properties?.transportHelicopterDurationHour).toFixed(2) : '',
          suffix: 'hours'
        },
        transportHelicopterFreqTravel: {
          caption: Labels.LBL_TRAVEL_TO_RIG_FREQ,
          value: oilGasDetailsAttr?.proposal_attr.properties?.transportHelicopter == 'Yes' && oilGasDetailsAttr?.proposal_attr.properties?.transportHelicopterFreqTravel,
          suffix: 'per annum'
        },
        otherTransport: {
          caption: 'Other transport mode',
          value: oilGasDetailsAttr?.proposal_attr.properties?.transportOther,
        },
      } : null,
      resTravelDetails: resTravelDetailsAttr ? {
        durationOfResidence: {
          caption: Labels.LBL_TRAVEL_DURATION,
          value: resTravelDetailsAttr?.proposal_attr.properties?.durationOfResidence,
          suffix: 'months'
        },
        residenceAddr: {
          caption: Labels.LBL_RESIDENTIAL_OR_TRAVEL_ADDRESS,
          value: await UtilBloc.capitalizeWords(
            (resTravelDetailsAttr?.proposal_attr.properties?.residenceAddr ? resTravelDetailsAttr?.proposal_attr.properties?.residenceAddr + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.postcode ? resTravelDetailsAttr?.proposal_attr.properties?.postcode + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.city ? resTravelDetailsAttr?.proposal_attr.properties.city + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.state ? resTravelDetailsAttr?.proposal_attr.properties.state + ', ' : '') +
            (residenceCountry ? residenceCountry : '')
          )
        },
        stayTime: {
          caption: Labels.LBL_TRAVEL_TIME,
          value: resTravelDetailsAttr?.proposal_attr.properties?.stay,
          suffix: 'months'
        },
        firstVisit: {
          caption: Labels.LBL_FIRST_VISIT,
          value: resTravelDetailsAttr?.proposal_attr.properties?.firstVisit,
        },
        firstVisitDetails: {
          caption: Labels.LBL_FIRST_VISIT_DETAILS,
          value: resTravelDetailsAttr?.proposal_attr.properties?.firstVisitDetails,
        },
        locationRemaining: {
          caption: Labels.LBL_REMAIN_TRAVEL,
          value: resTravelDetailsAttr?.proposal_attr.properties?.locationRemaining,
        },
        otherStayAddr: {
          caption: Labels.LBL_OTHER_LOCATION,
          value: UtilBloc.capitalizeWords(resTravelDetailsAttr?.proposal_attr.properties?.locationRemaining == 'No' ?
            (resTravelDetailsAttr?.proposal_attr.properties?.otherStayAddr ? resTravelDetailsAttr?.proposal_attr.properties?.otherStayAddr + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.otherStayPostcode ? resTravelDetailsAttr?.proposal_attr.properties?.otherStayPostcode + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.otherStayCity ? resTravelDetailsAttr?.proposal_attr.properties?.otherStayCity + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.otherStayState ? resTravelDetailsAttr?.proposal_attr.properties?.otherStayState + ', ' : '') +
            (resTravelDetailsAttr?.proposal_attr.properties?.otherStayCountry ? resTravelDetailsAttr?.proposal_attr.properties?.otherStayCountry : '') +
            (otherStayCountry ? otherStayCountry : '')
            : ''
          )
        },
        accomType: {
          caption: Labels.LBL_LIVING_CONDITIONS,
          value: resTravelDetailsAttr?.proposal_attr.properties?.accomType,
        },
        accomLocated: {
          caption: Labels.LBL_LOCATION_ACCOMMODATION,
          value: resTravelDetailsAttr?.proposal_attr.properties?.accomLocated,
        },
        workingCond: {
          caption: Labels.LBL_LIVING_WORKING_CONDITIONS,
          value: resTravelDetailsAttr?.proposal_attr.properties?.workingCond,
        },
        politicCond: {
          caption: Labels.LBL_POLITICAL_SITUATIONS,
          value: resTravelDetailsAttr?.proposal_attr.properties?.politicCond,
        },
      } : null,
      uploaded_document: response.data?.uploaded_document?.data,
      submitReview: submitReviewAttr?.proposal_attr?.properties || '',
      generatedDocuments: {
        caption: Labels.LBL_GENERATED_DOCUMENTS,
        data: generatedDocument,
      },
      documentRequirement: requirement,
    };

    return data;
  }

  static filterDetailsByQuestionNo(dataArr, el) {
    if (dataArr) {
      return dataArr.filter((item) => item.questionNo == el);
    } else {
      return [];
    }
  }

  static async getAllGeneratedDocuments(proposalId, quotationId, userId) {
    let payload = {
      proposalId,
      quotationId,
    };
    let result = {};

    let response = await ListingWebServices.getAllDocuments(payload, userId);

    if (response.success) {
      result = this.mapProposalGeneratedDocuments(response);
    }
    return result;
  }

  static async getProposalDocumentById(proposalId) {
    let resp = await ProposalServices.getProposalDocument(proposalId);
    let uploadedDocument = [];
    resp.data?.length > 0 && resp.data.forEach((item) => {
      let record = {};
      let format = item.uploaded_document.properties.format;
      let type = '';

      if (format == "PDF") {
        type = "application";
      } else {
        type = "image";
      }

      record = {
        filename: item?.uploaded_document.properties.filename,
        value: item?.uploaded_document.id,
        size: item?.uploaded_document.properties.sizeMB,
        type: item?.uploaded_document.properties.format,
        content: `data:${type}/${format};base64,${item?.uploaded_document.content}`
      };
      uploadedDocument.push(record);
    });
    if (resp.success) {
      return new DataResult(true, resp.message, uploadedDocument);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static mapProposalGeneratedDocuments(response) {
    let generatedDocument = [];

    // Getting Generated Documents
    response.data.forEach((item) => {
      let record = {};
      record = {
        caption: item.document.name,
        value: item?.uploaded_document.id,
        size: item?.uploaded_document.properties.sizeMB,
        type: item?.uploaded_document.properties.format,
      };
      generatedDocument.push(record);
    });

    let data = {
      generatedDocuments: {
        caption: Labels.LBL_GENERATED_DOCUMENTS,
        data: generatedDocument,
      },
    };

    return data;
  }

  static async completeReview(proposalId) {
    let resp = await ProposalServices.completeReview(proposalId);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getClientSignature(proposalId) {
    let resp = await ProposalServices.getClientSignature(proposalId);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async editProposal(proposalId) {
    try {
      let resp = await ProposalServices.editProposal(proposalId);
      if (resp.success) {
        return true;
      }
      return false;
    } catch { }
  }
}

export default ProposalBloc;
